var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#7074CA",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 28C24 24.8174 25.2643 21.7652 27.5147 19.5147C29.7652 17.2643 32.8174 16 36 16C39.1826 16 42.2348 17.2643 44.4853 19.5147C46.7357 21.7652 48 24.8174 48 28H50C51.0609 28 52.0783 28.4214 52.8284 29.1716C53.5786 29.9217 54 30.9391 54 32V52C54 53.0609 53.5786 54.0783 52.8284 54.8284C52.0783 55.5786 51.0609 56 50 56H22C20.9391 56 19.9217 55.5786 19.1716 54.8284C18.4214 54.0783 18 53.0609 18 52V32C18 30.9391 18.4214 29.9217 19.1716 29.1716C19.9217 28.4214 20.9391 28 22 28H24ZM36 20C38.1217 20 40.1566 20.8429 41.6569 22.3431C43.1571 23.8434 44 25.8783 44 28H28C28 25.8783 28.8429 23.8434 30.3431 22.3431C31.8434 20.8429 33.8783 20 36 20ZM40 40C40 40.7021 39.8151 41.3919 39.4641 41.9999C39.113 42.608 38.6081 43.1129 38 43.464V46C38 46.5304 37.7893 47.0391 37.4142 47.4142C37.0391 47.7893 36.5304 48 36 48C35.4696 48 34.9609 47.7893 34.5858 47.4142C34.2107 47.0391 34 46.5304 34 46V43.464C33.2375 43.0237 32.6415 42.3441 32.3046 41.5306C31.9677 40.7171 31.9086 39.8152 32.1365 38.9647C32.3644 38.1142 32.8665 37.3627 33.5651 36.8266C34.2636 36.2906 35.1195 36 36 36C37.0609 36 38.0783 36.4214 38.8284 37.1716C39.5786 37.9217 40 38.9391 40 40Z",
    fill: "#7074CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.df6d5f4ffadcfd49665b16b03f8d6443.svg";
export { ForwardRef as ReactComponent };